import React, {useCallback, useRef, useState} from 'react';
import Layout from "@/components/layout/main";
import {useTranslation} from "next-i18next";
import MetaBlock from "@/base/components/MetaBlock";
import {useNotification} from "@/base/components/NotificationProvider";
import {useUser} from "@/base/components/auth/UserProvider";
import {ModifyURL} from "@/base/utils/fetch";
import {BlacklistResponse} from "@/base/types/BlacklistResponse";
import {CartType} from "@/base/types/Cart/CartType";
import DashboardError from "@/base/components/dashboard/DashboardError";

type Props = {}

export default function Page({}: Props) {
	const {t} = useTranslation();

	const [data, setData] = useState<[CartType | string, boolean][]>([]);

	const [api] = useNotification();

	const [loading, setLoading] = useState(false);

	const siteRef = useRef<any>(null);

	const UserContext = useUser();

	// const [output, setOutput] = useState<BlacklistResponse | null>(null);

	const onCheck = useCallback(async (site: string) => {
		const domain = site.replace(/(^\w+:|^)\/\//, '').split('/')[0];

		setLoading(true);

		return UserContext.Fetch({
			url: ModifyURL('/blacklist/check'),
			params: {
				domain
			}
		}).then((res: { data: BlacklistResponse | null }) => {
			if (!res || !res.data)
			{
				throw new Error('Invalid response');
			}

			setData(Object.entries(res.data.blacklist));
		}).catch((err: any) => {
			api.error({
				message: err.message || err
			});
		}).finally(() => setLoading(false));
	}, [UserContext, api]);

	return <div className={`grid gap-4 gap-y-16 md:gap-y-16 xl:container max-xl:mx-4 relative`}>
		<div className={`col-span-full space-y-5`}>
			<DashboardError/>
		</div>
	</div>
};

Page.getLayout = function getLayout(page: any) {
	return <Layout rootClassName={`!bg-gradient-to-br from-red-400/[0.03] to-amber-100/10`}>
		<MetaBlock
			title={t => t('base-common:meta.404.title')}
			description={t => t('base-common:meta.404.description')}
		/>

		{page}
	</Layout>;
};